<template>

<div align="justify">
    <p class="h4" align="center">Реклама на сайте</p>
    <div align="justify">
        По вопросам размещения рекламы обращайтесь по телефону <strong style="color: blue;">8 (8216) 74-07-09</strong>
        или по электронной почте <strong style="color: blue;">ukhta1@mail.ru</strong>
    </div>
    
</div>

</template>

<script>
export default {
    name: 'PageContacts',
    methods: {
        func1: function(){
            alert("+++");
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    
    
</style>

